import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getTradeUnion,updateTradeUnion } from "../../actions/tradeUnionActions";
import classnames from "classnames";
import Select from 'react-select';

class EditTradeUnion extends Component {
  constructor() {
    super();
    this.state = {
        id:"",
      tuName: "",
      abbreviation:"",
      address: "",
      phone: "",
      tuPercentage:"",
      baseCurrency:"",
      errors:{}
    };
    this.saveTradeUnion = this.saveTradeUnion.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
  }


  componentDidMount() {
    const { tradeUnionId } = this.props.match.params;
    
    this.props.getTradeUnion(tradeUnionId, this.props.history);
  }

  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
   
    const{
        id,
        tuName,
        abbreviation,
        address,
        phone,
        tuPercentage,
        baseCurrency
    }=nextProps.tradeUnion

    this.setState({
        id,
        tuName,
        abbreviation,
        address,
        phone,
        tuPercentage,
        baseCurrency
    });
    
 }

  onChange = e => this.setState({ [e.target.name]: e.target.value });
  handleCurrencyChange(val) {
    this.setState({ baseCurrency: val.value });
  }

  saveTradeUnion = e => {
    e.preventDefault();
    let tradeUnion = {
        id:this.state.id,
        tuName:this.state.tuName,
        abbreviation:this.state.abbreviation,
        address: this.state.address,
        phone: this.state.phone,
        tuPercentage:this.state.tuPercentage,
        baseCurrency:this.state.baseCurrency
      
    };

    this.props.updateTradeUnion(tradeUnion,this.props.history);
    
  };

  cancel() {
    this.props.history.push("/tradeUnion-list");
  }
  
  render() {
    const { errors } = this.state;
    const currencies=[{value:"ZWL",label:"ZWL"},{value:"USD",label:"USD"}]
  
    return (
      <div className="container mt-4">
       
       <div className="card m-auto  border-primary shadow-lg rounded p-3">
            <h5 className="display-4 text-center">Edit Trade Union Details</h5>
            <hr />
            {errors.message &&<div className="alert alert-danger text-center" role="alert">
              {errors.message}
            </div>}
            <form onSubmit={this.saveTradeUnion}>
              <div className="form-group">
                <label >TU Name</label>
                <input
                className={classnames("form-control",
                {"is-invalid":errors.tuName})}
                  type="text"
                  name="tuName"
                  id="tuName"
                  value={this.state.tuName}
                  onChange={this.onChange}
                  placeholder="TU Name"

                />
                {errors.tuName && (
                      <div className="invalid-feedback">
                        {errors.tuName}
                      </div>
                    )}
              </div>
              <div className="form-group">
                <label >Abbrevation</label>
                <input
                className={classnames("form-control",
                {"is-invalid":errors.abbreviation})}
                  type="text"
                  name="abbreviation"
                  id="abbreviation"
                  value={this.state.abbreviation}
                  onChange={this.onChange}
                  placeholder="Abbrevation"

                />
                {errors.abbreviation && (
                      <div className="invalid-feedback">
                        {errors.abbreviation}
                      </div>
                    )}
              </div>
              <div className="form-group">
                <label >Address</label>
                <input
                className="form-control"
                  type="text"
                  name="address"
                  id="address"
                  value={this.state.address}
                  onChange={this.onChange}
                  placeholder="Address"
                />
              </div>
              <div className="form-group">
                <label >Phone</label>
                <input
                className="form-control"
                  type="text"
                  name="phone"
                  id="phone"
                  value={this.state.phone}
                  onChange={this.onChange}
                  placeholder="Phone"
                />
              </div>
              <div className="form-group">
                <label >Percentage</label>
                <input
                className="form-control"
                  type="decimal"
                  name="tuPercentage"
                  id="tuPercentage"
                  min={0.0}
                  value={this.state.tuPercentage}
                  onChange={this.onChange}
                  placeholder="Percentage"
                />
              </div>
              <div className="form-group">
                <label>Base Currency</label>
                <Select
                  className="react-selectcomponent"
                  classNamePrefix="name-select"
                  onChange={this.handleCurrencyChange}                 
                  options={currencies}
                  value={{label : this.state.baseCurrency}}
                  required
                />
              </div>
              <div className="row">
              <div className="form-group col-sm-6">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mt-4"
                  
                >Save</button>
                </div>
                <div className="form-group col-sm-6">
                <button
                  type="button"
                  className="btn btn-secondary btn-block mt-4"
                  onClick={this.cancel}
                >Cancel</button>
              </div>
              </div>
            </form>
          </div>
        </div>
    
    );
  }
}

EditTradeUnion.propTypes = {
  getTradeUnion: PropTypes.func.isRequired,
   // updateTradeUnion: PropTypes.func.isRequired,
    tradeUnion: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
  };
  
  const mapStateToProps = state => ({
    tradeUnion:state.tradeUnion.tradeUnion,
    errors: state.errors
  });
  
  export default connect(
    mapStateToProps,
    { getTradeUnion,updateTradeUnion}
  )(EditTradeUnion);
